import * as React from 'react';
import { EHonestWorkIconSize } from './constants';
import * as styles from './index.css';

export interface IUserWorkHonestlyIconProps {
  levelNumber: number;
  size?: EHonestWorkIconSize;
}

export const UserWorkHonestlyIcon = ({ levelNumber, size }: IUserWorkHonestlyIconProps) => {
  return (
    <div
      className={`${styles['icon']} ${styles[`icon--${levelNumber}`]} ${
        size === EHonestWorkIconSize.Small ? styles['icon--small'] : ''
      }`}
    />
  );
};
